import {
  queryOptions,
  useQuery,
  useSuspenseQuery,
} from "@tanstack/react-query";

import { userApi } from "@shared/api";

export const myAccountQueryOptions = (
  refetchInterval?: number,
  refetchOnWindowFocus = false,
  refetchOnMount = false,
) =>
  queryOptions({
    queryFn: () => userApi.getApiV1AccountsMy(),
    queryKey: ["account-my"],
    refetchInterval,
    refetchOnMount,
    refetchOnWindowFocus,
  });

export const useMyAccount = (
  refetchInterval?: number,
  refetchOnWindowFocus = false,
  refetchOnMount = false,
) => {
  const { data, error, refetch, isPending } = useSuspenseQuery(
    myAccountQueryOptions(
      refetchInterval,
      refetchOnWindowFocus,
      refetchOnMount,
    ),
  );

  return {
    error,
    myAccount: data.data,
    refetch,
    isPending,
  };
};

export const useMyAccountQuery = (
  refetchInterval?: number,
  refetchOnWindowFocus = false,
  refetchOnMount = false,
) => {
  const { data, error, refetch, isError, isLoading } = useQuery(
    myAccountQueryOptions(
      refetchInterval,
      refetchOnWindowFocus,
      refetchOnMount,
    ),
  );

  return {
    error,
    myAccount: data?.data,
    refetch,
    isError,
    isLoading,
  };
};
